import basePath from "base_path";
import ActionTypes, {WorkflowsActionTypes} from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {LlmRunId, LlmRunTestResults} from "common/flowmaster/types/llm_run";

export type WorkflowTestResultFetchAction = {
  type: WorkflowsActionTypes["WORKFLOW_TEST_RESULT_FETCH"]["SUCCESS"];
  payload: {dataKey: string; key: string; results: LlmRunTestResults[]};
};

export default function getTestResults(requestor) {
  return createReduxPromiseAction(
    ActionTypes.WORKFLOW_TEST_RESULT_FETCH,
    (
      organisationId: OrganisationId,
      llmRunId: LlmRunId,
      dataKey: string,
      key: string,
    ) => {
      return requestor
        .get(
          `${basePath}/organisation/${organisationId}/llm_run/${llmRunId}/data_key/${dataKey}/key/${key}`,
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return {
            dataKey,
            key,
            results: response.data,
          };
        });
    },
  );
}
